/**
 * @author Vladislav Urbánek <urbanek.vlada@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import StateMachine from './state-machine';

/**
 * Továrna na konečný stavový automat.
 */
export default class StateMachineFactory {
  /**
   * Vytvoří nový konečný stavový automat.
   * @param {import('javascript-state-machine').StateMachineConfig} options
   * @returns {import('./state-machine').default} Vytvořený konečný stavový automat.
   */
  create(options) {
    return new StateMachine(options);
  }
}
